var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user.type != 'guest')?_c('div',{staticClass:"pr-2 pt-2"},[_c('router-link',{attrs:{"to":{
      name:
        _vm.company?.type === 'group'
          ? 'category-menu'
          : _vm.hasGroupGoodMenu(_vm.company)
          ? 'category-menu-add'
          : 'company-menu',
    }}},[_c('img',{staticStyle:{"width":"50px"},attrs:{"id":"ordera_logo","src":'https://restorani.bitlab.host/img/o.png',"alt":"image"}})])],1):_c('div',{staticClass:"pr-2"},[_c('a',{attrs:{"href":"/#/guest"}},[_c('img',{staticStyle:{"width":"110px"},attrs:{"src":'https://app.restorani.bitlab.host/gallery/logo.png',"alt":"image"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }